// Show Hide
const showHideElements = document.querySelectorAll('.show-hide');
showHideElements.forEach((showHideElement) => {
   const showHideContent = showHideElement.querySelector('.show-hide-content');
   const showHideBtn = showHideElement.querySelector('.show-hide-btn');

   if (showHideContent && showHideBtn) {
       showHideBtn.addEventListener('click', () => {
           showHideElement.classList.toggle('active');

           if (showHideElement.classList.contains('active')) {
               showHideContent.style.maxHeight = showHideContent.scrollHeight + 'px';
           } else {
               showHideContent.style.maxHeight = '';
           }
       });
   }
});
